export const PROFILE_THEME_CHANGED = 'Profile Theme Changed'; // params: name, oldTheme
export const PROFILE_FONT_CHANGED = 'Profile Font Changed'; // params: name
